<div class="wrapper">
  <mat-card class="mat-elevation-z2">
    <mat-card-content>
      <div
        [innerHTML]="
          'FIRST_LOGIN.DESCRIPTION_HTML'
            | translate
              : {
                  firstName: firstName ? firstName : '',
                  lastName: lastName,
                  company: environment.customer,
                  linkToFAQ: environment.linkToFAQ
                }
        "
      ></div>
    </mat-card-content>
    <ng-container *ngIf="environment.enableManualAccountLinking" style="margin-top: 3rem">
      <div>
        <mat-form-field>
          <mat-label>{{ 'FIRST_LOGIN.INPUT_PLACEHOLDER' | translate }}</mat-label>
          <input #input matInput maxlength="12" />
        </mat-form-field>
        <div>
          <span class="error-text" *ngIf="c4LoginFailedAttempts > 1">
            {{ 'FIRST_LOGIN.LINKING_ERROR' | translate }}
            <ng-container *ngIf="environment.customerServiceEmail"
              ><br />{{ 'FIRST_LOGIN.EMAIL' | translate }}{{ environment.customerServiceEmail }}</ng-container
            >
            <ng-container *ngIf="environment.customerServicePhone"
              ><br />{{ 'FIRST_LOGIN.PHONE' | translate }}{{ environment.customerServicePhone }}</ng-container
            >
          </span>
        </div>
      </div>
      <mat-card-actions>
        <button
          mat-flat-button
          (click)="submit(input.value)"
          [disabled]="isInvalidInput(input.value) || currentPendingState === pendingStateEnum.pending"
          [class.button-spinner]="currentPendingState === pendingStateEnum.pending"
        >
          {{ 'FIRST_LOGIN.BUTTON_TEXT' | translate }}
        </button>
      </mat-card-actions>
    </ng-container>
  </mat-card>
</div>
